import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {RichText} from 'prismic-reactjs';
import {Helmet} from 'react-helmet-async';

const Legal = () => {
    const page = useSelector(state => state.page);

    return (
        <div className="Legal container">
            <Helmet>
                <title>{page['meta-title']}</title>
                <meta name="description" content={page['meta-desc']} />
                <body className="legal-page" />
            </Helmet>
            {RichText.render(page.title)}
            {RichText.render(page.content)}
        </div>
    );
};

Legal.propTypes = {
    page: PropTypes.shape({
        title: PropTypes.array,
        content: PropTypes.array,
        'meta-title': PropTypes.string,
        'meta-desc': PropTypes.string,
    }),
};

export default Legal;
